import { render, staticRenderFns } from "./ProfileDetailsPage.vue?vue&type=template&id=91e37a82&scoped=true&"
import script from "./ProfileDetailsPage.vue?vue&type=script&lang=ts&"
export * from "./ProfileDetailsPage.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileDetailsPage.vue?vue&type=style&index=0&id=91e37a82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91e37a82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VContainer,VDivider,VIcon})
